<template>
  <div>
    <div v-for="alert in data" :key="alert.id" class="ltr">
      <FeedContent :alert="alert" />
      <div v-if="alertResource(alert).length > 0" class="">
        <div v-if="alertResource(alert) != 'offer'">
          <LinkEntity
            :payload="alert.resources[alertResource(alert)]"
            :additional_data="{ ...(alertResource(alert) == 'position' && { resource_type: 'Position' }) }" />
          <br />
          <GhanaFlag v-if="alertResource(alert) != 'company'" :payload="alert.resources[alertResource(alert)]" :additional_data="{ ...(alertResource(alert) == 'position' && { resource_type: 'Position' }) }" />
          <br />
          <LinkEntity v-if="alertResource(alert) == 'position'" :payload="alert.resources['company']" />
        </div>
        <div v-else>
          <LinkEntity :payload="alert.resources.applicant" />
          <br />
          <GhanaFlag :payload="alert.resources.applicant" />
          <br />
          <LinkEntity :payload="alert.resources.position" :additional_data="{ resource_type: 'Position' }" />
          <br />
          <GhanaFlag :payload="alert.resources.position" :additional_data="{ resource_type: 'Position' }" />
          <br />
          <LinkEntity :payload="alert.resources.company" />
          <br />
        </div>
      </div>
      <div class="columns has-text-left note">
        <div class="column">
          <p>Designator: {{ alert.designator }}</p>
          <p>Duration: {{ alert.duration }}</p>
          <p>Message: {{ alert.message }}</p>
        </div>
        <div class="column">
          <p>Title: {{ alert.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeedContent from '@/components/FeedContent'
import LinkEntity from '@/components/LinkEntity'
import GhanaFlag from '@/components/GhanaFlag'
export default {
  name: 'ModalAdminInProgress',
  components: {
    FeedContent,
    LinkEntity,
    GhanaFlag
  },
  props: {
    owner: {
      type: String
    }
  },
  data () {
    return {
      data: null
    }
  },
  created () {
    this.getAlerts()
  },
  methods: {
    alertResource (alert) {
      const resource = alert.resource_type || ''
      return resource.toLowerCase()
    },
    getAlerts () {
      this.$network_utils
        .getAllAlerts({
          page: 1,
          per: 10,
          owner: this.owner,
          statuses: 'done',
          sort: '-updated_at'
        })
        .then((response) => {
          this.data = response
        })
    }
  }
}
</script>

<style scoped>
.note {
  margin-bottom: 10px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.18);
}
</style>
